<div class="history-container">
    <div class="current-schedule-body">
        <h1 class="insight-title">{{ eventName }}</h1>
        <p class="event-place">{{ eventPlace }}</p>
        <p>{{ feedback }}</p>
        <div class="current-schedule-details">
            <div class="details-item">
                <img src="/assets/img/dueDate.svg" alt="Due Date Icon" />
                <p>
                    Applied: <span class="bold-text">{{ dueDate }}</span>
                </p>
            </div>
            <div class="details-item">
                <img
                    src="/assets/img/defaultPerson.svg"
                    alt="Assigned Person Icon"
                />
                <p>
                    Assigned to: <span class="bold-text">{{ assignedTo }}</span>
                </p>
            </div>
        </div>
    </div>
    <div class="history-status">{{ eventStatus }}</div>
</div>
